import axios from 'axios';
import Vue from 'vue';

const state = { status: '', userById: {}, currentUser: parseInt(localStorage.getItem('user_id'),10), user: {}, error: {}};

const getters = {
  //getProfile: state => state.profile,
  getTopActivity: state => state.user.top_activity,
  //isProfileLoaded: state => !!state.profile.email,
  user: state => state.user,
  error: state => state.error,
  getCurrentUser: state => state.currentUser,
  getUserById: state => state.userById,
  getStatus: state => state.status,
};

const actions = {
  getUser({commit, dispatch}, user_id) {
    return new Promise((resolve, reject) => {
      commit('requestUser');
    //const user_id = localStorage.getItem('user_id');
    if (!user_id) {
      user_id = localStorage.getItem('user_id');
    }
    axios({url: `${process.env.VUE_APP_ROOT_API}/users/${user_id}/`})
      .then(resp => {
        if (resp) {
          const user = resp.data;
          commit('setUser', user);
        }
        resolve(resp);
      })
      .catch(error => {
       reject(error);
      })
    })
  },
  getUserById({commit, dispatch}, user_id) {
    return new Promise((resolve, reject) => {
      commit('requestUser');
    axios({url: `${process.env.VUE_APP_ROOT_API}/users/${user_id}/`})
      .then(resp => {
        if (resp) {
          const user = resp.data;
          commit('setUserById', user);
        }
        resolve(resp);
      })
      .catch(error => {
       reject(error);
      })
    })
  },
  updateUser({commit, dispatch}, user) {
    return new Promise((resolve, reject) => {
      const user_id = localStorage.getItem('user_id');
      axios({url: `${process.env.VUE_APP_ROOT_API}/users/${user_id}/`, data: user, method: 'PATCH', headers: {'Content-Type': 'multipart/form-data'}})
      .then(resp => {
        if (resp) {
          const user = resp.data;
          commit('setUser', user);
        }
        resolve(resp);
      })
      .catch(error => {
        const err = error.response.data;
        commit('setError', err);
        reject(error);
      })
    })
  },
  updateTeam ({commit, dispatch}, team) {
    return new Promise((resolve, reject) => {
      const user_id = localStorage.getItem('user_id');
      axios({url: `${process.env.VUE_APP_ROOT_API}/users/${user_id}/team/`, data: team, method: 'PATCH', headers: {'Content-Type': 'multipart/form-data'}})
      .then(resp => {
        if (resp) {
          const team = resp.data;
          commit('setTeam', team);
        }
        resolve(resp);
      })
      .catch(err => {
        commit('setError', err)
        reject(err)
      })
    })
  },
  deleteTrack ({commit, dispatch}, track_id) {
    return new Promise((resolve, reject) => {
      const user_id = localStorage.getItem('user_id');
      axios({url: `${process.env.VUE_APP_ROOT_API}/users/${user_id}/track/${track_id}/`, method: 'DELETE'})
      .then(resp => {
        commit('deleteTrack', track_id);
        resolve(resp);
      })
      .catch(err => {
        commit('setError', err)
        reject(err)
      })
    })
  },
  updateTeamAvatar ({commit, dispatch}, team) {
    return new Promise((resolve, reject) => {
      const user_id = localStorage.getItem('user_id');
      axios({url: `${process.env.VUE_APP_ROOT_API}/users/${user_id}/team/`, data: team, method: 'PATCH', headers: {'Content-Type': 'multipart/form-data'}})
      .then(resp => {
        if (resp) {
          const team = resp.data;
          commit('setTeamAvatar', team);
        }
        resolve(resp);
      })
      .catch(err => {
        commit('setError', err)
        reject(err)
      })
    })
  },
};

const mutations = {
  requestUser(state){
    state.status = 'loading';
  },
  setUser (state, user) {
    state.status = 'success';
    state.user = user;
   // state.currentUser = user.id;
  },
  setUserById (state,user){
    state.status = 'success';
    state.userById = user;
  },
  deleteTrack (state, track_id) {
    state.user.user_activity = state.user.user_activity.filter(actvity => actvity.id != track_id)
  },
  setTeam (state, team) {
    state.user.user_team[0] = team;

  },
  setTeamAvatar (state, team) {
    state.user.user_team[0].avatar = team.avatar;
  },
  setError (state, error) {
    state.status = 'error';
    state.error = error;
  },

};
const namespaced = true;
export default {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
